import { render } from "./CTextCardRequrenmentRules.vue?vue&type=template&id=561bc14f"
import script from "./CTextCardRequrenmentRules.vue?vue&type=script&lang=js"
export * from "./CTextCardRequrenmentRules.vue?vue&type=script&lang=js"

import exportComponent from "/buddy/vue-imprint-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__